var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTextMiddle)?_c('div',{staticClass:"text-middle"},[_c('p',{staticClass:"text-title"},[_vm._t("title")],2),_vm._v(" "),_c('p',{staticClass:"text-message"},[_vm._t("message")],2)]):_c('div',{class:_vm.styleType})}
var staticRenderFns = []

export { render, staticRenderFns }